export default __webpack_public_path__ + "static/media/olympSuperSlim.73546b28.jpg";